"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortfolioIntegrationTypeEnum = void 0;
var PortfolioIntegrationTypeEnum;
(function (PortfolioIntegrationTypeEnum) {
    PortfolioIntegrationTypeEnum["Trading212"] = "trading212";
})(PortfolioIntegrationTypeEnum = exports.PortfolioIntegrationTypeEnum || (exports.PortfolioIntegrationTypeEnum = {}));
//# sourceMappingURL=portfolio-integration-type-enum.js.map